module.exports = __webpack_public_path__ + "static/media/02_web_website-symbol.f5678206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_website-symbol.jpg
// module id = 73
// module chunks = 0